import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const miscForm: Form<Client> = {
  key: 'miscForm',
  fields: [
    {
      key: 'consultationOccasion',
      label: 'Beratungsanlass',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        {
          value: 'sexViolenceUpToSixMonths',
          label: 'Sex Gewalt bis 6 Monate:  Belästigung / Nötigung / Vergewaltigung',
        },
        {
          value: 'sexViolenceFromSixMonths',
          label: 'Sex Gewalt ab 6 Monate: Belästigung / Nötigung / Vergewaltigung',
        },
        {
          value: 'abuse',
          label: 'Missbrauch',
        },
        {
          value: 'mentalViolence',
          label: 'Psychische Gewalt',
        },
        {
          value: 'physicalViolence',
          label: 'Physische Gewalt',
        },
        {
          value: 'domesticViolence',
          label: 'Häusliche Gewalt',
        },
        {
          value: 'stalking',
          label: 'Stalking',
        },
        {
          value: 'sexualHarassmentAtWork',
          label: 'Sexuelle Belästigung am Arbeitsplatz',
        },
        {
          value: 'digitalViolence',
          label: 'Digitale Gewalt',
        },
        {
          value: 'coDrops',
          label: 'KO Tropfen',
        },
        {
          value: 'ritualOrganisedViolence',
          label: 'Rituelle, organisierte Gewalt',
        },
        {
          value: 'securityAdvice',
          label: 'Sicherheitsberatung',
        },
        {
          value: 'violenceProtectionActCounselling',
          label: 'Gewaltschutzgesetzberatung',
        },
        {
          value: 'stabilization',
          label: 'Stabilisierung',
        },
        {
          value: 'custody',
          label: 'Umgang / Sorgerecht',
        },
        {
          value: 'consultationOccasionOther',
          label: 'Sonstiges',
        },
      ],
    },
    {
      key: 'consultationOccasionOther',
      label: 'Sonstiger Beratungsanlass',
      fieldTypes: 'text',
      xsWidth: 12,
      isVisible: (client) =>
        client.consultationOccasion != null && client.consultationOccasion.includes('consultationOccasionOther'),
    },
    {
      key: 'suspectedDiagnosis',
      label: '(Verdachts-) Diagnosen',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        { value: 'physicalDisability', label: 'Körperbehinderung' },
        { value: 'intellectualDisability', label: 'Geistige Behinderung' },
        { value: 'mentalDisability', label: 'Psychische Behinderung' },
        { value: 'threatenedByMentalDisability', label: 'von psychischer Behinderung bedroht' },
        { value: 'developmentallyDelayed', label: 'entwicklungsverzögert' },
      ],
    },
    {
      key: 'mentalDisability',
      label: 'Seelische Behinderung',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      isVisible: (client) =>
        client.suspectedDiagnosis != null && client.suspectedDiagnosis.includes('mentalDisability'),
      options: [
        { value: 'trauma', label: 'Trauma' },
        { value: 'addiction', label: 'Sucht' },
        { value: 'depression', label: 'Depression' },
        { value: 'borderline', label: 'Borderline' },
        { value: 'suicidality', label: 'Suizidalität' },
        {
          value: 'selfHarmingBehaviour',
          label: 'Selbstverletzendes Verhalten',
        },
        { value: 'mentalDisability2Other', label: 'Sonstiges' },
      ],
    },
    {
      key: 'mentalDisability2Other',
      label: 'Sonstige seelische Behinderung',
      fieldTypes: 'text',
      isVisible: (client) =>
        client.mentalDisability != null && client.mentalDisability.includes('mentalDisability2Other'),
    },
    {
      key: 'timeSinceAssault',
      label: 'Zeit seit dem Übergriff',
      fieldTypes: 'select',
      options: [
        { value: 'fourWeeks', label: '4 Wochen' },
        { value: 'threeMonths', label: '3 Monate' },
        { value: 'upToSixMonths', label: 'Bis 6 Monate' },
        { value: 'fromSixMonths', label: 'Ab 6 Monate' },
        { value: 'moreThanFiveYears', label: 'Mehr als 5 Jahre' },
        { value: 'moreThanTenYears', label: 'Mehr als 10 Jahre' },
      ],
    },
    {
      key: 'arrangedVia',
      label: 'Wege zu uns',
      fieldTypes: 'select',
      options: [
        { value: 'internet', label: 'Internet' },
        { value: 'helpHotline', label: 'Hilfetelefon' },
        { value: 'police', label: 'Polizei' },
        { value: 'youthWelfareService', label: 'Jugendamt' },
        { value: 'otherConsultingCenter', label: 'andere Fachstelle' },
        { value: 'doctors', label: 'Kliniken/Ärzte/Ärztinnen' },
        { value: 'weisserRing', label: 'Weißer Ring' },
        { value: 'therapist', label: 'Therapeut*innen' },
        { value: 'school', label: 'Schule' },
        { value: 'privateCaregivers', label: 'private Bezugspersonen' },
        { value: 'unknown', label: 'unbekannt' },
        { value: 'arrangedViaOther', label: 'Sonstige' },
      ],
    },
    {
      key: 'arrangedViaOther',
      label: 'Sonstiger Weg zu uns',
      fieldTypes: 'text',
      isVisible: (client) => client.arrangedVia != null && client.arrangedVia === 'arrangedViaOther',
    },
  ],
};

export default miscForm;
